
<div class="container" *ngIf="showMetricas">
  <!--TOMADOR-->
    <app-header-title title="Métricas de Tomador" classTitle="title__bold__gray" *ngIf="showTomador" subTitle="Consulte todos os casos">
    </app-header-title>

    <ngu-carousel #carouselTomador [inputs]="carouselConfig" [dataSource]="carouselItemsTomador" *ngIf="showTomador">
      <ngu-tile class="metricas-container" *nguCarouselDef="let item;">
        <div class="item">
          <div class="metricas-container2">
            <div class="subitem1">
              <div class='size-x circle' (click)="tomador ? redirectTo('tomador', item?.idPesquisa) : ''" *ngIf="!screenLoading">{{item?.metricaTomador}}</div>
              <div class='size-x circle' *ngIf="screenLoading">
                <app-gradient-loading></app-gradient-loading>
              </div>
            </div>

            <div class="subitem2">
              <div class="subitem2-title">
                <p>Tomadores</p>
                <p>{{item?.metricaSubTitulo}}</p>
                <p *ngIf="tomador">Seu caminho mais rapido, consulte aqui! </p>
              </div>
            </div>            
          </div>
        </div>
      </ngu-tile>
      <button NguCarouselNext class="rightRs"><span class="mat-button-wrapper">
        <mat-icon role="img" class="mat-icon mat-accent">arrow_forward</mat-icon>
      </span></button>
	    <button NguCarouselPrev class="leftRs"><span class="mat-button-wrapper">
        <mat-icon role="img" class="mat-icon mat-accent">arrow_back</mat-icon>
      </span></button>
    </ngu-carousel>

    <!-- <div class="metricas-container">
      <div class="item">
        <div class="metricas-container2">
          <div class="subitem1" (click)="tomador ? redirectTo('tomador', 3) : ''">
            <div class='size-x circle' *ngIf="!screenLoading">{{this.homeMetricas?.metricasTomadores?.totalTomadoresSemEmissao}}</div>
            <div class='size-x circle' *ngIf="screenLoading">
              <app-gradient-loading></app-gradient-loading>
            </div>
          </div>
          <div class="subitem2">
            <div class="subitem2-title">
              <p>Tomadores</p>
              <p>Sem Emissão</p>
              <p *ngIf="tomador">Seu caminho mais rapido, consulte aqui! </p>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="metricas-container2">
          <div class="subitem1" (click)="tomador ? redirectTo('tomador', 4) : ''">
            <div class='size-x circle' *ngIf="!screenLoading">{{this.homeMetricas?.metricasTomadores?.totalTomadoresLimiteExcedido}}</div>
            <div class='size-x circle' *ngIf="screenLoading">
              <app-gradient-loading></app-gradient-loading>
            </div>
          </div>
          <div class="subitem2">
            <div class="subitem2-title">
              <p>Tomadores</p>
              <p>com Limite atingido</p>
              <p *ngIf="tomador">Seu caminho mais rapido, consulte aqui! </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  <hr *ngIf="showTomador">

  <!--PROPOSTAS-->
  <app-header-title title="Métricas de Propostas" classTitle="title__bold__gray" subTitle="Consulte todos os casos">
  </app-header-title>

  <div class="metricas-alert">
    <img class="metricas-alert-icon" src="../../../assets/icons/AlertCircleFilled.svg">
    <div class="metricas-alert-text" *ngIf="vinculoCorretora">
      As informações são atualizadas 4 vezes ao dia
    </div>
    <div class="metricas-alert-text" *ngIf="!vinculoCorretora">
      As métricas apresentadas não contemplam operações feitas em outros canais que não seja o HUB.
    </div>
  </div>

  <ngu-carousel #carouselPropostas [inputs]="carouselConfig" [dataSource]="carouselItemsPropostas" style="margin-bottom: 30px;">
    <ngu-tile class="metricas-container" *nguCarouselDef="let item">
      <div class="item">
        <div class="metricas-container2">
          <div class="subitem1">
            <div class='size-x circle' (click)="propostas ? redirectTo('propostas', item?.idPesquisa) : ''" *ngIf="!screenLoading">{{item?.metricaProposta}}</div>
            <div class='size-x circle' *ngIf="screenLoading">
              <app-gradient-loading></app-gradient-loading>
            </div>
          </div>

          <div class="subitem2">
            <div class="subitem2-title">
              <p>Propostas</p>
              <p>{{item?.metricaSubTitulo}}</p>
              <p *ngIf="propostas">Seu caminho mais rapido, consulte aqui! </p>
            </div>
          </div>            
        </div>
      </div>
    </ngu-tile>
    <button NguCarouselNext class="rightRs"><span class="mat-button-wrapper">
      <mat-icon role="img" class="mat-icon mat-accent">arrow_forward</mat-icon>
    </span></button>
    <button NguCarouselPrev class="leftRs"><span class="mat-button-wrapper">
      <mat-icon role="img" class="mat-icon mat-accent">arrow_back</mat-icon>
    </span></button>
  </ngu-carousel>
  <br>
</div>